import * as v from 'valibot';

const RegionLiteralSchema = v.union([
  v.literal('eu'),
  v.literal('us'),
  v.literal('in'),
  v.literal('EU'),
  v.literal('US'),
  v.literal('IN'),
]);

export const RegionSchema = v.pipe(
  v.string(),
  v.transform(value => value.toLowerCase()),
  RegionLiteralSchema,
);

export const CallAppSettingsSchema = v.object({
  appId: v.string(),
  region: RegionSchema,
  authKey: v.optional(v.string()),
  adminHost: v.optional(v.string()),
  clientHost: v.optional(v.string()),
  host: v.optional(v.string()),
});

export type CallAppSettings = v.InferOutput<typeof CallAppSettingsSchema>;
